import { getFirstSelectedInvoiceStreamId } from '@/shared/components/registration/registrationHelpers';
import angular from 'angular';

angular
  .module('cloudX')
  .controller('UpdateRegistrationRelationDialogCtrl', [
    '$scope',
    '$element',
    'flySvc',
    'appUrls',
    '$http',
    'close',
    'registration',
    'showAddToDraft',
    updateRegistrationRelationDialogCtrl,
  ]);

function updateRegistrationRelationDialogCtrl(
  $scope,
  $element,
  flySvc,
  appUrls,
  $http,
  close,
  registration,
  showAddToDraft,
) {
  const vm = this;
  if (!registration) return;
  vm.registration = registration;
  vm.showAddToDraft = showAddToDraft;
  vm.relation = null;
  vm.invoiceStreamId = null;
  vm.invoiceStreams = [];
  vm.addToDraftInvoice = false;
  vm.saving = false;

  vm.relationChanged = function(relation) {
    vm.relation = relation;

    if (!vm.relation || !vm.relation.id) {
      vm.invoiceStreamId = null;
      vm.invoiceStreams = [];
    } else {
      vm.invoiceStreamId = getFirstSelectedInvoiceStreamId(vm.relation);
      vm.invoiceStreams = vm.relation.invoiceStreams || [];
    }
  };

  vm.save = function() {
    if (!vm.invoiceStreamId) return;
    if (vm.saving) return;
    vm.saving = true;
    $http
      .put(`${appUrls.api}/api/InvoiceRegistration/ChangeRelation`, {
        id: vm.registration.id,

        invoiceStreamId: vm.invoiceStreamId,
        addToDraftInvoice: vm.addToDraftInvoice,
      })
      .then(
        ({ data }) => {
          $element.modal('hide');
          close(data, 500);
          vm.saving = false;
        },
        error => {
          flySvc.error(error);
          vm.saving = false;
        },
      );
  };
  vm.cancel = function() {
    close(null, 500);
  };
}
